import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import {
  AggregatorDictResponse
} from '@/open-api/models';
import { BaseApi } from '@/api/base-api';

export class AggregatorsApi extends BaseApi {
  private controller = '/common/catalog';

  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  public async apiV1DictAggregatorsGet(): Promise<AggregatorDictResponse[]> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/dict/aggregators?withProviders=true`,
      {}
    );
  }
}
